export default class BaseModal {

	constructor(modalBg, modal) {
		this.modalName = modal;
		this.modalbg = document.getElementById(modalBg);
		this.modal = document.getElementById(modal);
    this.onKeydownCallback = this.onKeydown.bind(this);
    this.headerLogoLink = document.getElementById('logo-link');
	}

	init () {
		this.description = this.modal.querySelector('.description');
    this.descriptionWrapper = this.modal.querySelector('.description-wrapper');
    this.modalHeader = this.modal.querySelector('.modal-header');
    this.value = this.modal.querySelector('.value');

		document.querySelector('#'+this.modalName+' .modal-close').addEventListener('click', () => {
			this.hide();
		});

    this.modalbg.addEventListener('click', () => {
			this.hide();
		});

    if (this.descriptionWrapper) {
      window.addEventListener('resize', () => {
        this.setDescriptionWrapperHeight(window.innerWidth);
      });
    }
	}

  setDescriptionWrapperHeight (windowWidth) {
    if(windowWidth < 996) {
      this.descriptionWrapper.style.height = (window.innerHeight-this.header) + 'px';
    } else if(windowWidth >= 996 && windowWidth < 1280) {
      this.descriptionWrapper.style.height = (window.innerHeight - 88) + 'px';
    } else {
      this.descriptionWrapper.style.height = ((window.innerHeight - window.innerHeight * .25) - 100) + 'px';
    }
  }

	show (setFocusTrap = true) {
    if(this.modalHeader) {
      this.header = this.modalHeader.offsetHeight;
    }

    if(this.description) {
      this.setDescriptionWrapperHeight(window.innerWidth);

      if(this.value && !this.value.classList.contains('hidden')) {
        this.modal.classList.remove('overflow-hidden');
        this.modal.classList.add('overflow-y-auto');
        this.descriptionWrapper.classList.remove('overflow-y-auto');
        this.descriptionWrapper.style.height = 'auto';
      } else {
        this.modal.classList.remove('overflow-y-auto');
        this.modal.classList.add('overflow-hidden');
        this.descriptionWrapper.classList.add('overflow-y-auto');
      }
    }

    this.modalbg.classList.remove('invisible', 'opacity-0');
		this.modalbg.classList.add('opacity-1');
		this.modal.classList.remove('invisible', 'opacity-0', 'scale-75');
		this.modal.classList.add('opacity-1', 'transition-all', 'duration-300');
		document.body.classList.add('overflow-hidden');

    this.modal.scrollTop = 0;

    if(this.descriptionWrapper) {
      this.descriptionWrapper.scrollTop = 0;
    }

    let siblings = this.getSiblings(this.modal);
    siblings.forEach(e => e.setAttribute('aria-hidden', 'true'));
    siblings.forEach(e => e.setAttribute('inert', 'true'));

    document.getElementById('footer').setAttribute('inert', 'true');
    document.getElementById('footer').setAttribute('aria-hidden', 'true');

    if(setFocusTrap) {
      this.focusTrap();
    }
	}

	hide () {
		this.modalbg.classList.add('opacity-0');
		this.modal.classList.add('opacity-0', 'scale-75');
		this.modalbg.classList.remove('opacity-1');
		this.modal.classList.remove('opacity-1');
		setTimeout(() => {
			this.modalbg.classList.add('invisible');
			this.modal.classList.add('invisible');
			document.body.classList.remove('overflow-hidden');
		}, 300)

    let siblings = this.getSiblings(this.modal);
    siblings.forEach(e => e.removeAttribute('aria-hidden'));
    siblings.forEach(e => e.removeAttribute('inert'));

    document.getElementById('footer').removeAttribute('inert');
    document.getElementById('footer').removeAttribute('aria-hidden');
    document.removeEventListener('keydown', this.onKeydownCallback);

    if(this.modalTrigger) {
      this.modalTrigger.focus();
    } else {
      this.headerLogoLink.focus();
    }
	}

  onKeydown (e) {
    if (e.key === "Escape") {
      this.hide();
      if(this.modalTrigger) {
        this.modalTrigger.focus();
      } else {
        this.headerLogoLink.focus();
      }
    }

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === this.firstFocusableElement) {
          this.lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        // FIX
        if (document.activeElement === this.lastFocusableElement) {
          this.firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  }

  focusTrap () {
    this.modalTrigger = document.activeElement;
    const focusableElements = 'button:not(.hidden), [href]:not(.hidden), input:not(.hidden), select:not(.hidden), textarea:not(.hidden), [tabindex]:not([tabindex="-1"])';
    const focusableContent = this.modal.querySelectorAll(focusableElements);
    this.firstFocusableElement = focusableContent[0];
    this.lastFocusableElement = focusableContent[focusableContent.length - 1];

    setTimeout(() => this.firstFocusableElement.focus(), 300);

    document.addEventListener('keydown', this.onKeydownCallback);
  }

  getSiblings (e) {
    let siblings = [];

    if(!e.parentNode) {
        return siblings;
    }

    let sibling  = e.parentNode.firstChild;

    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e && sibling.id !== 'didomi-host' && !sibling.id.includes("modal-bg")) {
            siblings.push(sibling);
        }
        sibling = sibling.nextElementSibling;
    }
    return siblings;
  }
}
